import { render, staticRenderFns } from "./TouristVisa.vue?vue&type=template&id=a194bb34&"
import script from "./TouristVisa.vue?vue&type=script&lang=js&"
export * from "./TouristVisa.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports